import React from "react";
import Box from "@mui/material/Box";
import FiltersAndGrid from "./FiltersAndGrid";
import Typography from "@mui/material/Typography";

export default function DoubleFiltersGrids(props) {
	return (
		<Box
			sx={{
				display: "flex",
				width: "100%",
				height: "100%",
				flexDirection: "column",
			}}
		>
			{props.titles?.[0] && (
				<Typography
					align="center"
					sx={{
						fontWeight: "bold",
						fontSize: 15,
					}}
				>
					{props.titles[0]}
				</Typography>
			)}
			<FiltersAndGrid
				sx={{
					padding: 1,
				}}
				{...props.topProps}
			/>
			{props.titles?.[1] && (
				<Typography
					align="center"
					sx={{
						fontWeight: "bold",
						fontSize: 15,
						mt: 1, //margin-top
					}}
				>
					{props.titles[1]}
				</Typography>
			)}
			<FiltersAndGrid
				sx={
					props.bottomSX || {
						padding: 1,
						mt: 3, //margin-top
					}
				}
				{...props.bottomProps}
			/>
		</Box>
	);
}
